const IS_PRODUCTION = process.env.NODE_ENV === "production";
export const CONFIG = {
    isProd: IS_PRODUCTION,
    isMobile: /iPhone|iPad|iPod|Android/i.test(navigator.userAgent),
    IS_STAGE: process.env.ENVIRONMENT === "stage",
    AKINON_ENABLED: (url) => {
        try {
            const hostname = new URL(url).hostname;
            return ["uspoloassn.com", "localsite.supsis.live", "pierrecardin.com.tr", "cacharel.com.tr"].some((x) =>
                hostname.includes(x)
            );
        } catch (e) {
            return false;
        }
    },
    CHATBOT_NAMES: {
        "636cc65863315c9721e524e5": "Cacharel Asistan",
        "636cc67f63315c9721e52d51": "Pierre Cardin Asistan",
        "636cc622a5ba910cf051610e": "USPA Asistan",
        default: "Chatbot Asistan",
    },
    CHATBOT_IMAGES: {
        "636cc65863315c9721e524e5": "https://static.supsis.live/common/aydinli/cacharel-logo.png",
        "636cc67f63315c9721e52d51": "https://static.supsis.live/common/aydinli/pierre-cardin-logo.png",
        "636cc622a5ba910cf051610e": "https://static.supsis.live/common/aydinli/uspoloassn-logo.png",
        default: null,
    },
    VISITOR_SPECIAL_UI: {
        CACHAREL: "636cc65863315c9721e524e5",
        PIERRECARDIN: "636cc67f63315c9721e52d51",
        USPA: "636cc622a5ba910cf051610e",
    },
    IS_USPOLO: (url) => {
        if (url) {
            try {
                const hostname = new URL(url).hostname;
                return ["uspoloassn.com"].some((x) => hostname.includes(x));
            } catch (error) {
                console.error("Geçersiz URL:", url);
                return false;
            }
        } else {
            return false;
        }
    },

    IS_CACHAREL: (url) => {
        if (url) {
            try {
                const hostname = new URL(url).hostname;
                return ["cacharel.com.tr"].some((x) => hostname.includes(x));
            } catch (error) {
                console.error("Geçersiz URL:", url);
                return false;
            }
        } else {
            return false;
        }
    },
    IS_PIERRECARDIN: (url) => {
        if (url) {
            try {
                const hostname = new URL(url).hostname;
                return ["pierrecardin.com.tr"].some((x) => hostname.includes(x));
            } catch (error) {
                console.error("Geçersiz URL:", url);
                return false;
            }
        } else {
            return false;
        }
    },


};



// WEBPACK FOOTER //
// ./src/utils/config.js